import { NaturalNumber_Schema } from "@/utilities/schema";

export const CollectionItemId_Schema = NaturalNumber_Schema;
